export enum FeatureFlag {
  traceJsonRpc = 'traceJsonRpc',
  landingPage = 'landingPage',
  permit2 = 'permit2',
}
